import {
  useState,
  useCallback,
  useMemo,
} from 'react';

import {
  getDocuments,
  createDocument,
  updateDocument,
  deleteDocument,
} from '../../services';

export function useDocument() {
  const [ getting, setGetting ] = useState( false );
  const [ saving, setSaving ] = useState( false );
  const [ isOpenModal, setIsOpenModal ] = useState( false );

  const [ data, setData ] = useState([]);
  const [ document, setDocument ] = useState( null );

  const loadDocuments = useCallback( async () => {
    setGetting( true );

    const { success, message, result } = await getDocuments();

    if( success ) {
      setData( result );
    }

    setGetting( false );

    return { success, message };
  }, []);

  const handleOpenModal = useCallback(( data ) => {
    setDocument( data );

    setIsOpenModal( true );
  }, []);

  const handleCloseModal = useCallback(() => {
    setDocument( null );

    setIsOpenModal( false );
  }, []);

  const handleSave = useCallback( async ( formData ) => {
    setSaving( true );

    const { success, message } = document?._id
      ? document?.function === 'Excluir'
        ? await deleteDocument( document._id )
        : await updateDocument( document._id, formData )
      : await createDocument( formData );

    setSaving( false );

    if( success ) loadDocuments();

    return { success, message };
  }, [ document ]);

  return useMemo(() => ({
    data,
    document,
    getting,
    saving,
    isOpenModal,
    loadDocuments,
    handleOpenModal,
    handleCloseModal,
    handleSave,
  }), [
    data,
    document,
    getting,
    saving,
    isOpenModal,
    loadDocuments,
    handleOpenModal,
    handleCloseModal,
    handleSave,
  ]);
};
